<template>
    <section id="top_service_andtour" class="section_padding_top">
        <div class="container">
            <!-- Section Heading -->
            <div class="row">
                <div class="col-lg-12 col-md-12 col-sm-12 col-12">
                    <div class="section_heading_center">
                        <h2>And tour top services</h2>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-lg-4 col-md-6 col-sm-12 col-12">
                   <a href="https://jasmytrip.com/hotel" target="_blank"> <div class="top_service_boxed">
                        <img src="../../assets/img/icon/service-1.png" alt="icon">
                        <h3>Hotel Booking</h3>
                        <p>We provide quick and reliable hotel booking services, helping you find comfortable stays at the best rates for a stress-free travel experience.
                        </p>
                    </div></a>
                </div>
                <div class="col-lg-4 col-md-6 col-sm-12 col-12">
                    <a href="https://jasmytrip.com/" target="_blank"><div class="top_service_boxed">
                        <img src="../../assets/img/icon/service-2.png" alt="icon">
                        <h3>Flight Booking</h3>
                        <p>
                           We provide quick and reliable flight booking services, helping you find the best fares, flexible options, and a smooth, stress-free travel journey.
                        </p>
                    </div></a>
                </div>
                <div class="col-lg-4 col-md-6 col-sm-12 col-12">
                  <a href="https://thevisacentre.com.pk/" target="_blank">  <div class="top_service_boxed">
                        <img src="../../assets/img/icon/service-3.png" alt="icon">
                        <h3>Visa Consultancy</h3>
                        <p>
                         We provide quick and reliable visa services, helping you complete all necessary documentation easily and smoothly for a completely stress-free travel journey.
                        </p> 
                    </div></a>
                </div>
                <div class="col-lg-4 col-md-6 col-sm-12 col-12">
                    <a href="https://jasmytrip.com/cruise" target="_blank"><div class="top_service_boxed">
                        <img src="../../assets/img/icon/service-4.png" alt="icon">
                        <h3>Cruises Booking</h3>
                        <p>
                           We provide quick and reliable cruise booking services, helping you find the best cabins and options easily for a completely stress-free travel journey.
                        </p>
                    </div></a>
                </div>
                <div class="col-lg-4 col-md-6 col-sm-12 col-12">
                    <div class="top_service_boxed">
                        <img src="../../assets/img/icon/service-5.png" alt="icon">
                        <h3>Airport Transfer</h3>
                        <p>
                            We provide quick and reliable airport transfer services, helping you reach your destination safely and smoothly for a completely stress-free travel journey.
                        </p>
                    </div>
                </div>
                <div class="col-lg-4 col-md-6 col-sm-12 col-12">
                    <a href="https://thevisacentre.com.pk/countries/" target="_blank"><div class="top_service_boxed">
                        <img src="../../assets/img/icon/service-6.png" alt="icon">
                        <h3>Amazing Tour</h3>
                        <p>
                           We provide quick and reliable tour services, helping you plan and enjoy your trips easily and comfortably for a completely stress-free travel journey.
                        </p>
                    </div></a>
                </div>
            </div>
        </div>
    </section>
</template>
<script>

export default {
    name: "TopService"
};
</script>